<template>
  <body>

    <div class="myPost_wrapper">
      <!-- title -->
      <div class="main_top">
        <h1><img src ="images/basic/icon/back.svg" onclick="history.back()" class="back">  내가 좋아요한 글 <span id="thehae">{{ postCnt }}</span></h1>
        <img onclick="location.href='/community_write'" src="images/basic/icon/write.svg" alt="">
      </div>
      <div class="div_padding"></div>
      <template v-for="(posts, idx) in myPostList">
        <!-- board_list - 날짜별 -->
        <div class="board_wrapper" :key="idx">
          <div class="main_board">
            <div class="list_sort">
              <p>{{ posts[0].dateWeek }}</p>
            </div>
            <div class="board_list" v-for="(post, idx) in posts" :key="idx">
              <div @click="moveToCmView(post.boardId, post.nttId)">
                <div class="preview_text">
                  <p><span class="category">{{ post.boardNm }}</span>{{ post.nttSj }}</p>
                </div>
              <div class="preview_img" v-for="image in post.imgViewList" :key="image.orignlFileNm">
                <img :src="image.viewUrl" alt="">
              </div>
                <div class="preview_reply">
                  <span>{{ post.userInfo != undefined ? post.userInfo.name : "" }}</span>
                  <div class="">
                    <span><i class="far fa-comment-dots"></i> {{ post.commentCnt }}</span>
                    <span :class="post.likeYn == 'N'? 'like': 'like ed'"><i :class="post.likeYn == 'N' ? 'far fa-heart' : 'fas fa-heart'"></i> {{ post.likeCnt }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 일 단위 기준으로 끊고 광고 삽입 -->
        <div class="app_extanal" :key="posts.inqireCo">
          <img src="images/basic/img/external_img.png" alt="">
        </div>
      </template>
    </div>
  </body>
</template>

<script>
import { fetchMyLikeList } from '@/api/boards'
export default {
  data() {
    return {
      pageIndex: 1,
      myPostList: [],
      dateWeek: [],
      postCnt: 0,
      postLength: 0
    }
  },
  created() {
    fetchMyLikeList({
      pageIndex: this.pageIndex,
      recordCntOnPage: 10
    })
    .then(({ data }) => {
      this.myPostList = data.resultList
      this.postCnt = data.resultCnt 
    })
    .catch(err => {
      console.log(err);
    })
  },
  mounted() {
      var offset = 10;
      window.addEventListener('scroll', () => { // scroll event 등록
        if(window.$(window).scrollTop() > ( window.$(document).height() - window.$(window).height() ) - offset){
            this.fetchData();
        }
    });
  },
  methods: {
    moveToCmView(boardId, nttId) {
      this.$router.push({
         path: '/community_view', query: {
              boardId,
              nttId
         }
     })
    },
    fetchData() {
      this.postLength = 0;
      this.myPostList.filter((posts) => {
        posts.filter((post) => {
          this.postLength += 1;
        })
      })
    
      if(this.postLength < this.postCnt) {
        this.pageIndex += 1;
        fetchMyLikeList({
          pageIndex: this.pageIndex,
          recordCntOnPage: 10
        })
        .then(({ data }) => {
          const firstDateWeek = data.resultList[0][0].dateWeek
          const curIdx = this.myPostList.length -1
          const curDateWeek = this.myPostList[curIdx][0].dateWeek
      
          if(firstDateWeek == curDateWeek) {
           this.myPostList[curIdx] = [...this.myPostList[curIdx], ...data.resultList[0]];
           for(let i = 1; i < data.resultList.length; i++) {
             this.myPostList.push(data.resultList[i]);
           }

          } else {
             this.myPostList = [...this.myPostList, ...data.resultList];
          }
        })
      }
    }
  },

}
</script>

<style>

</style>